import { Box, Stack, Typography } from '@mui/material';
import { FINPSP_BANK_TYPE, FINPSP_DEPOSIT_TYPE, FINPSP_DEPOSIT_CHANNELS } from '../../../constants/finpsp';
import { getFinpspDepositType } from '../../../helpers/payment/finpsp';
import useLocalization from '../../../hooks/useLocalization';
import type { FinpspPayment } from '../../../types/finpsp';

const instructionKeys: Partial<Record<FinpspPayment['bank_type'], string[]>> = {
  [FINPSP_BANK_TYPE.BKASH]: [
    'finpspBkashStep1',
    'finpspSelectAction',
    'finpspBkashStep3',
    'finpspCashOutStep4',
    'finpspBkashStep5',
  ],
  [FINPSP_BANK_TYPE.NAGAD]: [
    'finpspNagadStep1',
    'finpspSelectAction',
    'finpspNagadStep3',
    'finpspCashOutStep4',
    'finpspNagadStep5',
  ],
};

const styles = {
  steps: {
    gap: 0.75,
  },
  step: {
    display: 'grid',
    gridTemplateColumns: 'max-content minmax(0, 1fr)',
    gap: 0.75,
    alignItems: 'baseline',
  },
  number: {
    color: 'text.secondary',
    fontVariantNumeric: 'tabular-nums',
  },
  text: {
    lineHeight: 1.5,
  },
  note: {
    mt: 0.5,
    pt: 2,
    borderTop: 1,
    borderColor: 'divider',
    lineHeight: 1.5,
    color: 'text.secondary',
  },
};

const FinpspPaymentSteps = ({ payment }: { payment: FinpspPayment }) => {
  const { t } = useLocalization();
  const depositType = getFinpspDepositType(payment);

  return (
    <Stack direction='column' sx={styles.steps}>
      <Typography component='h3' variant='subtitle2'>
        {t('finpspInstructions')}
      </Typography>
      {instructionKeys[payment.bank_type]?.map((key, index) => (
        <Box key={key} sx={styles.step}>
          <Typography variant='body2' sx={styles.number}>
            {index + 1}.
          </Typography>
          <Typography variant='body2' sx={styles.text}>
            {t(index === 2 && depositType !== FINPSP_DEPOSIT_TYPE.P2A ? 'finpspReceivingStep' : key, {
              sim_number: payment.sim_number,
              amount: payment.amount.toString(),
              action: t(FINPSP_DEPOSIT_CHANNELS[depositType].actionKey ?? 'deposit'),
            })}
          </Typography>
        </Box>
      ))}
      {depositType === FINPSP_DEPOSIT_TYPE.P2A && (
        <Typography variant='body2' sx={styles.note}>
          {t('finpspCashOutNote')}
        </Typography>
      )}
    </Stack>
  );
};

export default FinpspPaymentSteps;
